export default function authHeaderQueueJson() {
  let token = JSON.parse(localStorage.getItem("larToken"));
  if (token) {
    return {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      Authorization: `Bearer ${token}`,
    };
  } else {
    return {};
  }
}
